import { useTranslation } from "react-i18next";

import { useDropdownSourceContext } from "@ryde/redux";
import { capitalize, type IRouteSchedule } from "@ryde/shared";

import {
  buildDropdownLabelById,
  formatCourseScheduleCsvValue,
} from "./course-csv.utils";
import type { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvCourseScheduleCellTransformer = (): {
  getCourseScheduleValue: CsvCellTransformerFn;
} => {
  const { t } = useTranslation();
  const { getDropdownItems } = useDropdownSourceContext();

  const dayGroupLabel = capitalize(t("dayGroup.plural"));
  const dayTypeLabel = capitalize(t("dayType.plural"));

  const getCourseScheduleValue = async ({
    value,
  }: ICsvColumnTransformer): Promise<string> => {
    const schedules = value as IRouteSchedule[] | undefined;
    const [dayTypeItems, dayGroupItems] = await Promise.all([
      getDropdownItems?.("dayType"),
      getDropdownItems?.("dayGroup"),
    ]);

    return formatCourseScheduleCsvValue({
      schedules,
      dayTypeNameById: buildDropdownLabelById(dayTypeItems),
      dayGroupNameById: buildDropdownLabelById(dayGroupItems),
      dayTypeLabel,
      dayGroupLabel,
    });
  };

  return { getCourseScheduleValue };
};
